import { Button, Stack } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import type { ReactNode } from 'react';

type ColumnFilterContainerProps = {
  children: ReactNode;
  onReset: () => void;
};

/** Conteneur commun des filtres de colonne : champs + bouton de réinitialisation. */
const ColumnFilterContainer = ({ children, onReset }: ColumnFilterContainerProps) => {
  const { t } = useTranslate();

  return (
    <Stack gap="xs">
      {children}
      <Button variant="subtle" size="xs" onClick={onReset}>
        {t('common.filters.reset')}
      </Button>
    </Stack>
  );
};

export default ColumnFilterContainer;
